import { ApolloError, useQuery } from '@apollo/client'
import { createLocationsLayersCollection, createPolygonsLayersCollection } from 'features/RoutingLayers/models'

import { GET_ALL_ACTIVE_ROUTING_LAYERS } from 'features/RoutingLayers/queries'
import { ILocationsLayerModel, IPolygonsLayerModel } from 'features/RoutingLayers/types'

export const useAllActiveRoutingLayers = (): {
  polygonsLayers: IPolygonsLayerModel[]
  locationsLayers: ILocationsLayerModel[]
  loading: boolean
  error: ApolloError | null
} => {
  const { data, loading, error } = useQuery(GET_ALL_ACTIVE_ROUTING_LAYERS, {
    fetchPolicy: 'network-only'
  })
  const polygonsLayersCollection = createPolygonsLayersCollection(data?.routingLayers.items || [])
  const locationsLayersCollection = createLocationsLayersCollection(data?.routingLayers.items || [])

  return {
    polygonsLayers: polygonsLayersCollection.items,
    locationsLayers: locationsLayersCollection.items,
    loading,
    error: error || null
  }
}
